import { render, staticRenderFns } from "./AdminToolbar.vue?vue&type=template&id=3511efea"
import script from "./AdminToolbar.vue?vue&type=script&lang=js"
export * from "./AdminToolbar.vue?vue&type=script&lang=js"
import style0 from "./AdminToolbar.vue?vue&type=style&index=0&id=3511efea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports